<div class="d-flex flex-row mobile-heading-wrapper">
	<div class="col d-block d-sm-none">
		<button
			class="fa fa-bars fa-2x icon-bar"
			[attr.aria-expanded]="isShowMobileNav"
			(click)="toggleMobileActive()"
			aria-label="Menu"
		></button>
	</div>
	<div class="col d-flex d-block d-sm-none justify-content-end">
		<ea-client-logo></ea-client-logo>
	</div>
</div>
<!-- Sliding component for mobile view -->
<ea-slider
	class="d-block d-sm-none"
	[direction]="SliderDirection.Left"
	[duration]="constants.NOTIFICATIONS.SLIDER_DURATION"
	[sliderId]="constants.sliderIds.MOBILE_NAV"
	eaFocusTrap
>
	<ng-template #slidingPanel>
		<div class="row slider-header">
			<div class="col-2 d-flex">
				<button
					(click)="closeSlider()"
					[attr.aria-expanded]="isShowMobileNav"
					type="button"
					class="close-button-wrapper"
					aria-label="Close"
				>
					<span aria-hidden="true">
						<ea-icon [hasMargin]="false" name="close"></ea-icon>
					</span>
				</button>
			</div>
			<div class="col">
				<div class="d-flex justify-content-start">
					<ea-client-logo></ea-client-logo>
				</div>
			</div>
		</div>
		<div class="d-block d-sm-none mobile-menu-wrapper">
			<nav role="navigation" aria-label="mobile navigation">
				<ul>
					@for (item of navbarItems; track item) {
						<li>
							@if (item.show && !item.isExternalUrl) {
								<a
									#rla="routerLinkActive"
									[routerLink]="item.href"
									[attr.aria-current]="rla.isActive ? 'page' : null"
									(click)="closeSlider()"
									routerLinkActive="active">
									{{ item.display }}
								</a>
							}
							@if (item.show && item.isExternalUrl) {
								<a
									[href]="item.href"
									[attr.aria-current]="isActivePage(item.href) ? 'page' : null">
									{{ item.display}}
								</a>
							}
						</li>
					}
					<li>
						<div class="button-wrapper">
							@if (!isFranchiseOperator) {
								<tu-start-application-button
									buttonText="New Application"
									(startApplicationButtonClick)="navigateToFastTrackFlow()"
								>
								</tu-start-application-button>
							}
						</div>
					</li>
					@if (isSiteRedesignFeatureEnabled && isNotificationsEnabled) {
						<li>
							<ea-anchor
								class="mobile-menu-wrapper"
								[href]="constants.routes.notifications"
								[isRouterLink]="false"
								data-cy="mobile-notifications-link-text"
							>
								Notifications
							</ea-anchor>
						</li>
					}
					<li>
						<tu-support-services-mobile></tu-support-services-mobile>
					</li>
					<li>
						<tu-other-services-mobile></tu-other-services-mobile>
					</li>
					<li>
						<tu-profile-actions-mobile></tu-profile-actions-mobile>
					</li>
				</ul>
			</nav>
		</div>
	</ng-template>
</ea-slider>
